export default __webpack_public_path__ + "static/bwtransport-1-7cdba61269be83e491080786afacc846.png";